import axios from "axios";

const collectUTM = data => {
  const UTMS = ["utm_source", "utm_medium", "utm_content", "utm_campaign", "utm_term"];
  const splitURL = window.location.search.split("&");

  if (splitURL[1]) {
    splitURL.forEach(url => {

      UTMS.forEach(utm => {
        if (!data?.[utm]) {
          const splitUTM = url.split(`${utm}=`);
          data[utm] = splitUTM?.[1] || "";
        }
      });

    });
  }

  return data;
};

const formSuccess = (response, callback, callbackError, data) => {
  if (response && (response.status === 200 || response.status === 201)) {
    const data = response.data;
    return callback ? callback(data) : data;
  } else {
    return callbackError ? callbackError(data) : [];
  }
};

const formError = (error, callbackError) => callbackError ? callbackError(error) : [];

const API = (url, data, callback, callbackError, method = "POST", headers = {}) => {

  headers["params"] = {
    key: "0olIeQdYp3uAF7MI3z19LxSScY",
    is_published: 1,
  };

  url = "https://app.discount.lggiftwall.ru" + url;

  if (method === "POST") {
    data = collectUTM(data);

    let formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }

    data = formData;
  }

  const request = method === "GET" ? axios.get(url, headers) : axios.post(url, data, headers);

  request.then(response => formSuccess(response, callback, callbackError, data)).catch(error => formError(error, callbackError));

};

export default API;
